<template>
  <div :class="{ mp__body: headMp }">
    <LoadingJoinnus v-if="$store.getters.getloadingJoinnus"></LoadingJoinnus>
    <header :class="{ 'header-machupicchu': headMp, 'header-login': !headMp }">
      <nav class="navbar navbar-dark navbar-expand-sm" :class="{ 'shadow bg-dark': !headMp, container: headMp }">
        <button
          class="pr-3"
          v-if="$route.name !== 'Login'"
          v-b-toggle.sidebar-backdrop-menu
          style="border: 0; background-color: transparent"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
              d="M6.66667 30C6.19444 30 5.79861 29.8403 5.47917 29.5208C5.15972 29.2014 5 28.8056 5 28.3333C5 27.8611 5.15972 27.4653 5.47917 27.1458C5.79861 26.8264 6.19444 26.6667 6.66667 26.6667H33.3333C33.8056 26.6667 34.2014 26.8264 34.5208 27.1458C34.8403 27.4653 35 27.8611 35 28.3333C35 28.8056 34.8403 29.2014 34.5208 29.5208C34.2014 29.8403 33.8056 30 33.3333 30H6.66667ZM6.66667 21.6667C6.19444 21.6667 5.79861 21.5069 5.47917 21.1875C5.15972 20.8681 5 20.4722 5 20C5 19.5278 5.15972 19.1319 5.47917 18.8125C5.79861 18.4931 6.19444 18.3333 6.66667 18.3333H33.3333C33.8056 18.3333 34.2014 18.4931 34.5208 18.8125C34.8403 19.1319 35 19.5278 35 20C35 20.4722 34.8403 20.8681 34.5208 21.1875C34.2014 21.5069 33.8056 21.6667 33.3333 21.6667H6.66667ZM6.66667 13.3333C6.19444 13.3333 5.79861 13.1736 5.47917 12.8542C5.15972 12.5347 5 12.1389 5 11.6667C5 11.1944 5.15972 10.7986 5.47917 10.4792C5.79861 10.1597 6.19444 10 6.66667 10H33.3333C33.8056 10 34.2014 10.1597 34.5208 10.4792C34.8403 10.7986 35 11.1944 35 11.6667C35 12.1389 34.8403 12.5347 34.5208 12.8542C34.2014 13.1736 33.8056 13.3333 33.3333 13.3333H6.66667Z"
              fill="white"
            />
          </svg>
        </button>
        <router-link :to="{ name: 'Home' }" class="navbar-brand">
          <div class="d-flex align-items-center gap-4">
            <svg v-if="!headMp" version="1.1" height="35" fill="#00E5B5" class="d-inline-block align-top" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 948.1 270.9" style="enable-background:new 0 0 948.1 270.9;" xml:space="preserve">
              <g>
                <path class="st0" d="M135.5,0C60.7,0,0,60.7,0,135.5s60.7,135.5,135.5,135.5c74.8,0,135.5-60.7,135.5-135.5S210.3,0,135.5,0z
                  M202.9,157c0,18.2-14.8,33-33,33c-18.2,0-33-14.8-33-33v-43.1c0-5.2-4.2-9.4-9.4-9.4c-5.2,0-9.4,4.2-9.4,9.4V157
                  c0,18.2-14.8,33-33,33c-18.2,0-33-14.8-33-33c0-6.5,5.3-11.8,11.8-11.8c6.5,0,11.8,5.3,11.8,11.8c0,5.2,4.2,9.4,9.4,9.4
                  c5.2,0,9.4-4.2,9.4-9.4v-43.1c0-18.2,14.8-33,33-33c18.2,0,33,14.8,33,33V157c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4V92.7
                  c0-6.5,5.3-11.8,11.8-11.8c6.5,0,11.8,5.3,11.8,11.8V157z"/>
                <g>
                  <path class="st0" d="M407.3,75.4c-4.4,0-8,4.1-8,8.6v71.4c0,18.4-13.4,33.5-30.9,33.5c-17.7,0-31.3-15.2-31.3-33.5
                    c0-4.6-3.6-8.4-8-8.4c-4.4,0-8,3.7-8,8.4c0,27.8,20.6,48.5,47.2,48.5c26.3,0,47.1-22.5,47.1-50.3V84
                    C415.5,79.5,411.9,75.4,407.3,75.4z"/>
                  <circle class="st0" cx="539.8" cy="86" r="10.7"/>
                  <path class="st0" d="M472.5,108.3c-26.4,0-47.8,21.4-47.8,47.8s21.4,47.8,47.8,47.8c26.4,0,47.8-21.4,47.8-47.8
                    S498.9,108.3,472.5,108.3z M472.5,188.5c-17.9,0-32.4-14.5-32.4-32.4s14.5-32.4,32.4-32.4c17.9,0,32.4,14.5,32.4,32.4
                    S490.4,188.5,472.5,188.5z"/>
                  <path class="st0" d="M604.4,123.8c1.7-0.3,3.5-0.5,5.3-0.5c0,0,0,0-0.1,0C607.8,123.3,606.1,123.5,604.4,123.8z"/>
                  <path class="st0" d="M715.3,108.3c-0.3,0-0.5,0-0.8,0c-1.6,0-3.2,0.1-4.7,0.4c-8.7,1.1-16.6,5-22.8,10.6c0-0.5,0-0.9,0-0.9l0-2
                    c0-4.4-3.6-8-8-8h0c-4.4,0-8,3.6-8,8c0,13.2,0,37.9,0,37.9l0,18.8h0l0,5.5v0.1c0,0,0,0,0,0c0,5.1-4.1,9.2-9.2,9.3
                    c-5,0-9.1-4.1-9.1-9.1v-28.5c0-23.2-18.8-42-42-42c-0.3,0-0.5,0-0.8,0c-1.6,0-3.2,0.1-4.7,0.4c-8.7,1.1-16.6,5-22.8,10.6
                    c0-0.5,0-0.9,0-0.9l0-2c0-4.4-3.6-8-8-8h0c-4.4,0-8,3.6-8,8c0,13.2,0,37.9,0,37.9l0,24.5c0,0,0,0,0,0c0,5.1-4.1,9.3-9.3,9.3
                    c-5.1,0-9.3-4.1-9.3-9.3v-70.4h-16.1v72.1c0,13.1,10.8,23.6,23.9,23.6c12.6,0,26.2-9.9,27-22.3c0-0.1,0-0.2,0-0.2v-28.5
                    c0-1.2,0.1-2.4,0.2-3.6c0.3-12.6,9.4-23.1,21.5-25.5c1.7-0.4,3.5-0.5,5.2-0.5c0,0,0,0,0.1,0c0,0,0,0,0,0c11.4,0,21.1,7.1,25,17.2
                    c1.1,3,1.8,6.2,1.8,9.6v0c0,0.4,0,2.8,0,2.8l0,25.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1s0,0,0-0.1c0,0.7,0,1.3,0.1,1.9
                    c0,0,0,0,0-0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0.1,0.4c1.2,12.8,11.9,22.9,25,23c8.2-0.5,16.7-5,21.6-11.5c2.6-4,4.1-8.8,4.1-13.9
                    v-0.1c0,0,0,0,0,0v-25.4c0-1.2,0.1-2.4,0.2-3.6c0.3-12.6,9.4-23.1,21.5-25.5c1.7-0.4,3.5-0.5,5.2-0.5c0,0,0,0,0.1,0c0,0,0,0,0,0
                    c11.4,0,21.1,7.1,25,17.2c1.1,3,1.8,6.2,1.8,9.6v0c0,0.4,0,2.8,0,2.8l0,51h16.3v-53.5C757.4,127.1,738.5,108.3,715.3,108.3z"/>
                  <path class="st0" d="M850.2,108.8c-7.2,0-13.5,6.5-13.5,13.9v33.9c0,11.9-8.5,21.1-19.3,21.1c-10.9,0-19.5-9.3-19.5-21.1v-33.9
                    c0-7.5-6.2-13.9-13.5-13.9c-7.1,0-13.3,6.5-13.3,13.9v33.9c0,26.3,20.3,47,46.3,47c25.4,0,46.1-21.1,46.1-47v-33.9
                    C863.5,115.2,857.3,108.8,850.2,108.8z"/>
                  <path class="st0" d="M915.2,146.7c-8.9-1.9-16-3.4-16-8.8c0-3.7,2.8-8,10.6-8c6.6,0,10.9,2.1,14.7,4c3.3,1.6,6.2,3.1,10.3,3.1
                    c6.3,0,10.2-5.1,10.2-9.9c0-10.9-13.9-18.3-34.7-18.3c-20.2,0-36,12.8-36,29.1c0,21.6,19,25.7,32.9,28.6
                    c8.3,1.8,14.8,3.2,14.8,8.3c0,3.3-2.3,7.2-13.5,7.2c-7,0-11.1-2.2-14.6-4.1c-2.9-1.6-5.3-2.9-9.1-2.9c-6.2,0-10.8,4.6-10.8,10.8
                    c0,10.4,14.4,17.7,35,17.7c23,0,39-12.4,39-30.2C948.1,153.7,929.1,149.6,915.2,146.7z"/>
                </g>
              </g>
            </svg>
          </div>
        </router-link>
        <button @click="toggleNav = !toggleNav" class="navbar-toggler" type="button">
          <i v-if="toggleNav" class="material-icons">more_vert</i>
          <i v-else class="material-icons">close</i>
        </button>
        <div class="navbar-collapse" :class="{ collapse: toggleNav }">
          <!--<ul v-if="!headMp" class="navbar-nav mt-3 mt-sm-0">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Home' }"> Eventos </router-link>
            </li>
            <li class="nav-item d-none">
              <router-link class="nav-link" :to="{ name: 'Products' }"> Productos </router-link>
            </li>
          </ul>-->
          <ul v-if="isAuth" class="navbar-nav ml-auto" :class="{ author__container: headMp }">
            <li v-if="!headMp" class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Reports' }"> Reportes </router-link>
            </li>
            <li v-if="!headMp" class="nav-item" @click="logout()">
              <div class="nav-link">Cerrar sesión</div>
            </li>
            <li v-if="headMp" class="avatar">
              <span style="text-transform: capitalize; font-size: 24px;">{{ user.name }}</span>
              <picture class="d-flex align-items-center">
                <img v-if="user && user.avatar" :src="user.avatar" height="50" width="50" alt="avatar" />
                <ArrowDown />
              </picture>
              <ul>
                <li class="nav-item">
                  <a class="nav-link" @click="getSetting()" href="javascript:void(0);" title="configuración"
                    >Configuración</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" @click="logout()" href="javascript:void(0);" title="logout">Cerrar sesión</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <main :class="{ mp__main: headMp }">
      <slot />
    </main>
    <footer class="d-none">
      <div class="bg-dark py-2">
        <div class="container">
          <div class="row">
            <div class="col text-right">
              <img src="/images/poweredby-joinnus.svg" height="45" class="d-inline-block" alt="Jn" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { ArrowDown } from '@/assets/icons';
import api from '../api';
export default {
  components: { ArrowDown },
  data() {
    return {
      toggleNav: true,
    };
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.token;
    },
    console: () => console,
    headMp() {
      return this.$store.state.auth.user && this.$store.state.auth.roles.some((r) => r.name === 'agency');
    },
    user() {
      return this.$store.state.auth.user;
    },
    dateExpire() {
      return this.$store.state.auth.expire;
    },
    termsAndConditionsUrl() {
      return process.env.VUE_APP_TERM_CONDITIONS_URL;
    }
  },
  methods: {
    deleteCoupon() {
      this.$store.commit('updateCouponProducts', {
        type: 'percentage',
        value: '',
      });
    },
    deleteProfile() {
      this.$store.dispatch('resetState');
    },
    logout() {
      this.$router.push({ name: 'Logout' });
      this.deleteCoupon();
      this.deleteProfile();
    },
    toSettings() {
      this.$router.push();
    },
    getSetting() {
      this.$router.push({ name: 'Personal' });
    },
    async getData(q) {
      if (this.$store.getters.getListEvents.length === 0) {
        let activityId = null;
        this.$store.dispatch('changeLoadingJoinnus', true);
        try {
          let res = await api.getEvents(q, true);
          if (res.length > 0) {
            let arrActivity = res[0];
            if (arrActivity.activityId) {
              activityId = arrActivity.activityId;
              localStorage.setItem('activityId', activityId);
            }
            // let resEvents = await api.getListEvents({
            //   activityId: activityId,
            //   type: 'OFFLINE',
            // });
            // if (resEvents.data && resEvents.data.length > 0) {
            //   const payload = {
            //     access: this.$store.state.authAccess,
            //     data: resEvents.data,
            //   };
            //   this.$store.dispatch('setListEvents', payload);
            // }
          }
        } catch (error) {
          this.$router.push({ name: 'Logout' });
          console.log(error);
        } finally {
          this.$store.dispatch('changeLoadingJoinnus', false);
        }
      }
    },
  },
};
</script>
